import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'external-service-areas' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
